<template>
  <div class="w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3 mb-4">
    <vs-card
      id="aging_donut"
      class="vs-con-loading__container px-2 widget-card"
      style="position: relative"
    >
      <card-header :title="$t('widget_entries_by_aging')">
        <vx-tooltip delay="0.5s" text="Pallets" tooltipPosition="top">
          <feather-icon
            icon="LayersIcon"
            :style="{
              color: lastIconClicked == 'pallets' ? '#ba0000' : '#5d6063',
            }"
            svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
            @click="clickIconsAging('pallets')"
          />
        </vx-tooltip>
        <vx-tooltip delay="0.5s" text="Parcels" tooltipPosition="top">
          <feather-icon
            icon="BoxIcon"
            :style="{
              color: lastIconClicked == 'pallets' ? '#5d6063' : '#ba0000',
            }"
            svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
            @click="clickIconsAging('boxes')"
          />
        </vx-tooltip>
      </card-header>
      <vs-row>
        <vs-col>
          <div class="body-card-widget">
            <donut-chart
              :chartId="'entries-donut'"
              :height="'275'"
              :centerLabel="''"
              :valueFontSize="'15px'"
            />
          </div>
        </vs-col>
      </vs-row>
    </vs-card>
  </div>
</template>

<script>
import DonutChart from '@/views/apps/accounting/components/DonutChart.vue'
import entry from '@/http/requests/entry'
import loading from '@/mixins/Loading.js'
import CardHeader from './CardHeader.vue'

export default {
  mixins: [loading],
  components: {
    DonutChart,
    CardHeader,
  },
  computed: {
    isLoading() {
      return this.loading.aging_donut
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading('aging_donut')
      } else {
        this.closeLoading('aging_donut')
      }
    },
  },
  data() {
    return {
      colors: [],
      labelsDonut: [],
      permitList: [],
      lastIconClicked: 'pallets',
      params: {
        filter: 'pallets',
        status: ['1', '2', '4', '8'],
      },
      loading: {
        aging_donut: false,
      },
    }
  },
  mounted() {
    this.getInfo()
  },
  methods: {
    getInfo() {
      this.getCentralLabel()
      this.getSeriesDonut()
    },
    clickIconsAging(filter) {
      if (filter != this.lastIconClicked) {
        this.lastIconClicked = filter
        this.params.filter = filter
        this.getInfo()
      }
    },
    getSeriesDonut() {
      this.loading.aging_donut = true
      entry.getFirstDonut(this.params.filter).then((res) => {
        this.loading.aging_donut = false
        let arrayColors = []
        let labels = []
        let series = [0]
        let entries = res.data.data
        entries.forEach((item, index) => {
          series[index] = Number(item.total)
          labels[index] = item.ShortName
          arrayColors[index] = item.color
        })
        ApexCharts.exec(
          'entries-donut',
          'updateOptions',
          {
            fill: {
              colors: arrayColors,
            },
            legend: {
              markers: {
                fillColors: arrayColors,
              },
            },
            labels: labels,
            series: series,
          },
          false,
          true
        )
      })
    },
    getCentralLabel() {
      this.loading.aging_donut = true
      entry.averageAgingDonut(this.params.filter).then((res) => {
        this.loading.aging_donut = false
        let title = Number(res.data.data).toFixed(2)
        ApexCharts.exec(
          'entries-donut',
          'updateOptions',
          {
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    total: {
                      label: title,
                      formatter: function (w) {
                        return '(Average days Aging)'
                      },
                    },
                  },
                },
              },
            },
          },
          false,
          true
        )
      })
    },
  },
}
</script>